
  import { Vue, Component, Prop } from "vue-property-decorator";
  import DropdownFilter from "@/components/filters/DropdownFilterNew.vue";
  import DropdownOption from "@/entities/DropdownOption";

  @Component({
    components: {
      DropdownFilter,
    },
  })
  export default class PostedAtSelect extends Vue {
    @Prop({ type: String, required: true }) value!: string;
    @Prop({ type: Boolean, default: true }) withBorder!: boolean;
    @Prop({ type: String, default: "Select target" }) readonly placeholder!: string;
        @Prop({ type: String, default: "" }) readonly getcontainerStyle?: string;
            @Prop({ type: Boolean, default: false }) multiple!: boolean;
    @Prop({ type: Boolean, default: false}) disabled!: boolean;
    valueToSearch: string = ""

    postedAtOptions: DropdownOption[] = [
      { id: "none", name: "none" },
      { id: "marketplace", name: "marketplace" },
      { id: "internal", name: "internal" },
    ];

    get chosenOption(): DropdownOption[] {
      const option = this.postedAtOptions.find(({name}) => name === this.value);
      if (option) {
        return [option];
      }
      return [];
    }

    handleInput(val: DropdownOption[]): void {
      const data = val[0] ? val[0].name : ""
      this.$emit("input", data);
    }



  }
